export default __webpack_public_path__ + "static/media/1920 spice rack top.17866b9d.png";